enum State {
    PARTICLE = 0,
    FULL = 1
}

export default State;